import React, { useState } from 'react';
import styled from '@emotion/styled';
import NumericInput from 'react-numeric-input';

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: ${(props) => (props.reverse ? '70px' : 'auto')};
  .quantity-control {
    cursor: pointer;
    color: #7e57c2;
    font-size: 25px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;

    .fe-plus {
      margin-left: 5px;
    }
    .fe-minus {
      margin-right: 5px;
    }
  }
  .quantity-static-value {
    cursor: pointer;
    width: 100%;
    text-align: center;
  }
  input {
    width: 50px;
    text-align: center;
    border: 1px solid #ced4da;
    border-radius: 0.2rem;
    color: #72747b;
    line-height: 1.5;
  }
`;

const QuantityPicker = (props) => {
  const {
    value = 0,
    reverse = false,
    onChange,
    min = 0,
    max = undefined,
    className,
    prefix,
    hideInputOnBlur = false,
  } = props;

  const [showInput, setShowInput] = useState(false);

  const handleChangePlus = () => {
    const newValue = value + 1;
    if (newValue > max) return;
    onChange(newValue);
  };

  const handleChangeMinus = () => {
    const newValue = value - 1;
    if (newValue < min) return;
    onChange(newValue);
  };

  const handleOnBlurAction = () => {
    if (hideInputOnBlur) {
      hideInputOnBlur(setShowInput);
    }
  };

  return (
    <Wrapper reverse={reverse} className={`quantity-picker-wrapper ${className ? className : ''}`}>
      {!reverse ? (
        <div onClick={handleChangePlus} className="quantity-control">
          <i className="fe-plus" data-testid="plus" />
        </div>
      ) : value > 0 ? (
        <div onClick={handleChangeMinus} className="quantity-control">
          <i className="fe-minus" data-testid="minus" />
        </div>
      ) : null}
      {showInput ? (
        <NumericInput
          type="number"
          value={value}
          style={false}
          min={min}
          max={max}
          onChange={onChange}
          onBlur={() => handleOnBlurAction()}
        />
      ) : (
        <div className="quantity-static-value" onClick={() => setShowInput(true)}>
          {value} {prefix ? prefix : null}
        </div>
      )}
      {!reverse ? (
        value > 0 ? (
          <div onClick={handleChangeMinus} className="quantity-control">
            <i className="fe-minus" data-testid="minus" />
          </div>
        ) : null
      ) : (
        <div onClick={handleChangePlus} className="quantity-control">
          <i className="fe-plus" data-testid="plus" />
        </div>
      )}
    </Wrapper>
  );
};

export default QuantityPicker;
